import { Image } from './image.model';

export class Title {
  title_id: number;
  isbn: string;
  title: string;
  autor: string;
  linea_negocio: string;
  marca: string;
  tipo_articulo: string;
  preview_url: string;
  created_date: Date;
  images: Image;
  urlTitulo: string; 
  sublinea: string;
  tamano: string;

  /**
   * Constructor
   *
   * @param title
   */
  constructor(title) {
    this.title_id = title.title_id || 0;
    this.isbn = title.isbn || '';
    this.title = title.title || '';
    this.autor = title.autor || '';
    this.linea_negocio = title.linea_negocio || '';
    this.marca = title.marca || '';
    this.tipo_articulo = title.tipo_articulo || '';
    this.preview_url = title.preview_url || '';
    this.created_date = title.created_date || '';
    this.images = title.images || null;
    this.urlTitulo = title.urlTitulo || '';
    this.sublinea = title.sublinea || '';
    this.tamano = title.tamano || '';
  }
}
